import { Code, Shield, AlertTriangle, TrendingUp } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const SecureCodingHeroSection = () => {
  return (
    <section className="pt-24 pb-8 sm:pt-28 sm:pb-10">
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <Badge variant="outline" className="text-primary border-primary/30 bg-primary/5">
          <Code className="w-3 h-3 mr-1" />
          Development
        </Badge>
        <Badge variant="outline" className="text-muted-foreground border-border">
          14 min read
        </Badge>
      </div>

      <h1 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-foreground leading-tight mb-4">
        Secure Coding Practices:{" "}
        <span className="text-primary">OWASP Top 10</span> & Beyond
      </h1>

      <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-3xl mb-8">
        Essential security practices every developer should follow: input validation, authentication 
        best practices, OWASP Top 10, and secure API design patterns.
      </p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <Shield className="w-6 h-6 text-primary mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">70%</div>
          <div className="text-sm text-muted-foreground">Vulns preventable</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <AlertTriangle className="w-6 h-6 text-destructive mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">OWASP 10</div>
          <div className="text-sm text-muted-foreground">Top risks covered</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <Code className="w-6 h-6 text-chart-4 mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">50+</div>
          <div className="text-sm text-muted-foreground">Code examples</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <TrendingUp className="w-6 h-6 text-chart-2 mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">2024</div>
          <div className="text-sm text-muted-foreground">Latest standards</div>
        </div>
      </div>
    </section>
  );
};
